import { MutationTree } from 'vuex';
import { IPayoutState } from './types';

export const mutations: MutationTree<IPayoutState> = {
    SET_ALL_AFFILIATES_METHODS(state, payload) {
        state.allAffiliatesMethods = payload;
    },
};
